import React, { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { AdminDashboardStateResultsInterface } from '../../admin-dashboard-tables/interfaces';

const SellerAdsStateResults: React.FC<AdminDashboardStateResultsInterface> = ({
  searchResults,
  setHits,
  setExtraData,
  clearBulkSelected,
}) => {
  const [currentHits, setCurrentHits] = useState<any[]>([]);
  // Save the hit ids for use in the bulkSelector hook
  useEffect(() => {
    const newHits = searchResults?.hits
      ? searchResults?.hits.map((hit: { id: number }) => hit.id)
      : [];
    if (!isEqual(newHits, currentHits)) {
      // First, clear the currently selected hits, if any
      if (clearBulkSelected) {
        clearBulkSelected();
      }
      setCurrentHits(newHits);
    }

    if (setExtraData) {
      setExtraData(searchResults?.hits || []);
    }
  }, [searchResults]);

  useEffect(() => {
    setHits(currentHits);
  }, [currentHits]);

  // Get page
  // NOTE: `page` is zero-based from algolia
  const page = searchResults?.page || 0;

  // Get hits per page
  const hitsPerPage = searchResults?.hitsPerPage || 0;

  // Get total number of hits
  const nbHits = searchResults?.nbHits || 0;

  // Calculate first value in the range
  const beginRange = (page * hitsPerPage) + 1;

  // Calculate last value in the range
  let endRange = (page + 1) * hitsPerPage;
  if (endRange > nbHits) {
    endRange = nbHits;
  }

  if (nbHits === 0) {
    return (<p className="total-res my-4 mr-3 no-results">0 results found</p>);
  }

  return (
    /* NOTE: `toLocaleString()` adds comma for thousands, etc. */
    <p
      className="total-res my-4 mr-3"
    >
      {`Showing ${beginRange} - ${endRange} of ${nbHits.toLocaleString('en-US')} ${nbHits === 1 ? 'result' : 'results'}`}
    </p>
  );
};

export default SellerAdsStateResults;
